export default __webpack_public_path__ + "static/media/cancel-icon-na.335d5cba.svg";